export const hasSubscribed = 'has_subscribed';
export const isSubscribed = 'is_subscribed';
